import { defineType } from "sanity";

export default defineType({
  title: "Bloc Content",
  name: "simpleBlocContent",
  type: "array",
  of: [
    {
      title: "Block",
      type: "block",
      styles: [],
      lists: [
        { title: "Bullet", value: "bullet" },
        { title: "Numbered", value: "number" }
      ],
      marks: {
        decorators: [
          { title: "Strong", value: "strong" },
          { title: "Emphasis", value: "em" }
        ],
        annotations: [
          {
            title: "Action",
            name: "action",
            type: "object",
            fields: [
              {
                name: "type",
                type: "string",
                title: "Type",
                options: {
                  list: [{ title: "Open Chat", value: "open-chat" }]
                }
              }
            ]
          },
          {
            title: "URL",
            name: "link",
            type: "object",
            fields: [
              {
                title: "URL",
                name: "href",
                type: "string"
              },
              {
                title: "Open in new tab",
                name: "blank",
                description: "Read https://css-tricks.com/use-target_blank/",
                type: "boolean"
              }
            ]
          }
        ]
      }
    }
  ]
});
